// Code generated by master-scheme ServiceTypesGenerator - DO NOT EDIT
// Generator: /Users/victorvins/Projects/master-scheme/dsl/src/ts-api/ServiceTypesGenerator.scala

import { postEndpoint } from '@innolab-trader/tradovate-transport'
import type { ValidationError } from '@innolab-trader/tradovate-types'

export interface ChangePassword {
  name: string
  password: string
  permissionCode: string
  organization?: string
  locale?: string
}

export interface SimpleResponse {
  errorText?: string
  ok: boolean
}

/**
 * Validate ChangePassword request
 *
 * Follows Rust validation pattern with structured errors
 *
 * @param request - The request object to validate
 * @returns Array of validation errors, empty if valid
 *
 * @example
 * ```typescript
 * const errors = validateChangePassword(requestData)
 * if (errors.length > 0) {
 *   return { status: 400, errors }
 * }
 * ```
 */
export function validateChangePassword(request: ChangePassword): ValidationError[] {
  const errors: ValidationError[] = []

  const req = request as unknown as Record<string, unknown>
  if (req.name === undefined || req.name === null) {
    errors.push({
      field: 'name',
      code: 'required',
      message: 'name is required'
    })
  }
  if (typeof req.name === 'string' && req.name.length > 64) {
    errors.push({
      field: 'name',
      code: 'too_long',
      message: 'name must not exceed 64 characters',
      argument: '64'
    })
  }
  if (typeof req.name === 'string' && req.name.trim() === '') {
    errors.push({
      field: 'name',
      code: 'required',
      message: 'name cannot be empty'
    })
  }

  if (req.password === undefined || req.password === null) {
    errors.push({
      field: 'password',
      code: 'required',
      message: 'password is required'
    })
  }
  if (typeof req.password === 'string' && req.password.length > 64) {
    errors.push({
      field: 'password',
      code: 'too_long',
      message: 'password must not exceed 64 characters',
      argument: '64'
    })
  }
  if (typeof req.password === 'string' && req.password.trim() === '') {
    errors.push({
      field: 'password',
      code: 'required',
      message: 'password cannot be empty'
    })
  }

  if (req.permissionCode === undefined || req.permissionCode === null) {
    errors.push({
      field: 'permissionCode',
      code: 'required',
      message: 'permissionCode is required'
    })
  }
  if (typeof req.permissionCode === 'string' && req.permissionCode.length > 8192) {
    errors.push({
      field: 'permissionCode',
      code: 'too_long',
      message: 'permissionCode must not exceed 8192 characters',
      argument: '8192'
    })
  }
  if (typeof req.permissionCode === 'string' && req.permissionCode.trim() === '') {
    errors.push({
      field: 'permissionCode',
      code: 'required',
      message: 'permissionCode cannot be empty'
    })
  }

  if (typeof req.organization === 'string' && req.organization.length > 64) {
    errors.push({
      field: 'organization',
      code: 'too_long',
      message: 'organization must not exceed 64 characters',
      argument: '64'
    })
  }

  if (typeof req.locale === 'string' && req.locale.length > 64) {
    errors.push({
      field: 'locale',
      code: 'too_long',
      message: 'locale must not exceed 64 characters',
      argument: '64'
    })
  }

  return errors
}

export const changePassword = postEndpoint<ChangePassword, SimpleResponse>('/auth/changePassword')
